import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useDispatch } from "react-redux";
import { getAllUsers } from "../../service";
import { setLoading, setSelectedUser, setUsers } from "../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import editicon from "../../images/editIcon.png";
import Iconify from "../common/Iconify";
import Capsule from "../common/Capsule";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { useState } from "react";
import { utcTimetoLocalTimeWithzone } from "../common/TransForm/Localdateformater";
import { Dateformater } from "../common/TransForm/dateFormater";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Notification } from "../common/Notification";
import { hasWritePermission } from "../common/PermissionUtility";

export default function UserList() {
  const navigate = useNavigate();
  const { users } = useSelector((state) => state);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const [popUp,setPopup] = useState(false);
  const [amountPopup , setAmountPopup] = useState(false);
  const [tokenValue,setaddTokenValue] = useState(false)
  const [AmountTransfer , setAmountTransfer] = useState('');
  const [userId, setUserId] = useState("");
  const tokenFlag=process.env.REACT_APP_TOKEN_FLAG
  const [errorMessage, setErrorMessage] = useState('')
  const [notification,setnotification] = useState(false)
    // Server-side pagination states
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('');
    const [sortBy, setSortBy] = useState('');
     // ADD THIS: Server-side search state
  const [searchQuery, setSearchQuery] = useState('');
  const canWriteUsers = hasWritePermission('players');

  const handleNavigate =(data) => {
    navigate('player_details', {state:data} )
  }
  
  const userTableColumns = (params) => {
     let tablejson =  [
      // {
      //   key: "id",
      //   label: "Player ID",
      //   align: "left",
      //   fontSize: '15px',
      //   valueRenderer: (data) => {
      //     return (
      //       <Typography
      //         style={{ color: "#3C50E0", textUnderlineOffset:7, textDecoration:'underline', cursor:'pointer', width:'80px'  }}
      //         onClick={() => handleNavigate(data)}
      //       >
      //         {data["serial_no"]}
      //       </Typography>
      //     );
      //   },
  
      // },
      { key: "username", label: "User Name", align: "left", fontSize: "15px", 
           valueRenderer: (data) => {
          return (
            <Typography
              style={{ color: "#3C50E0", textUnderlineOffset:7, textDecoration:'underline', cursor:'pointer', width:'80px'  }}
              onClick={() => handleNavigate(data)}
            >
              {data["username"]}
            </Typography>
          );
        },
      },
      { key: "first_name", label: "Name", align: "left", fontSize: "15px", },
      { key: "email", label: "Email", align: "left" },
      { key: "mobile_number", label: "Mobile", align: "left", fontSize: "15px" },
      { key: "date_of_birth", label: "DOB", align: "left", fontSize: "15px", columnStyle: { minWidth: "120px", width: "120px" } },
      { key: "address_line_1", label: "Address Line 1", align: "left", fontSize: "15px", columnStyle: { minWidth: "150px", width: "150px" } },
       { key: "address_line_2", label: "Address Line 2", align: "left", fontSize: "15px", columnStyle: { minWidth: "150px", width: "150px" } },
      { key: "city", label: "City", align: "left", fontSize: "15px" },
      { key: "region", label: "Region", align: "left", fontSize: "15px" },
      { key: "country", label: "Country", align: "left", fontSize: "15px", columnStyle: { minWidth: "120px", width: "120px" } },
      { key: "nationality", label: "Nationality", align: "left", fontSize: "15px", columnStyle: { minWidth: "120px", width: "120px" } },
      {
        key: "last_played_date", label: "Last Played Date", align: "left", fontSize: "15px",
        valueRenderer: (data) => {
            if(data.last_played_date == null){
              return <Typography> N/A</Typography>
            }else{
              return <Typography>{Dateformater(data['last_played_date'])}</Typography>
            }
          
        },
      },
      { key: "available_tokens", label: "Purchased Tokens", align: "left", fontSize: "15px" },
      { key: "won_tokens", label: "Won Tokens", align: "left", fontSize: "15px" },
      {
        key: "Addtoken",
        label: "Add Tokens",
        align: "center",
        valueRenderer: (data) => {
          return (
            <Box sx={{ width: "180px"}}>
              <IconButton
                sx={{
                  "&:hover": {
                    // backgroundColor: 'transparent'
                    borderRadius: "12px",
                  },
                }}
                onClick={() => {
                  setPopup(true)
                  setUserId(data)}
  
                }
              >
                <Typography
                  sx={{
                    color: "#3C50E0",
                  
                    padding : '5px',
                    borderRadius:'10px',
                   
                    display: "flex",
                    gap: 2,
                    "&:hover": {
                      backgroundColor: "transparent",
  
                    },
                  }}
                  data={data.available_tokens ? data.available_tokens  : 0}
                >
                  Add Tokens
                  <Iconify
                    icon={editicon}
                    type="image"
                    size="small"
                    color="primary.main"
                  /> 
                  
                </Typography>
              </IconButton>
            </Box>
          );
        },
      },
      // {
      //   key: "AmountTransfered",
      //   label: "Amount Transfer",
      //   align: "center",
      //   valueRenderer: (data) => {
      //     return (
      //       <Box sx={{ width: "180px"}}>
      //         <IconButton
      //           sx={{
      //             "&:hover": {
      //               // backgroundColor: 'transparent'
      //               borderRadius: "12px",
      //             },
      //           }}
      //           onClick={() => {
      //             setAmountPopup(true)
      //             setUserId(data)}
  
      //           }
      //         >
      //           <Typography
      //             sx={{
      //               color: "#3C50E0",
                  
      //               padding : '5px',
      //               borderRadius:'10px',
                   
      //               display: "flex",
      //               gap: 2,
      //               "&:hover": {
      //                 backgroundColor: "transparent",
  
      //               },
      //             }}
      //             data={data.available_tokens ? data.available_tokens  : 0}
      //           >
      //             Amount Transfer
      //             <Iconify
      //               icon={editicon}
      //               type="image"
      //               size="small"
      //               color="primary.main"
      //             /> 
                  
      //           </Typography>
      //         </IconButton>
      //       </Box>
      //     );
      //   },
      // },

      { key: "total_rounds_playing", label: "Total Rounds", align: "left", fontSize: "15px" },
      { key: "active_rounds_playing", label: "Active Rounds", align: "left", fontSize: "15px" },
      { key: "total_gain_loss", label: "Total Gain/Loss", align: "left", fontSize: "15px" },
   
      {
        key: "is_active",
        label: "Status",
        align: "center",
        fontSize: '14px',
        valueRenderer: (data) => {
          if (data.is_active == true) {
            return <Capsule data='Active' bgColor='#21965333' color='#219653' sx={{width:'130px'}} />;
          } else {
            return <Capsule data='Inactive' bgColor='#87878714' color='#64748B' sx={{width:'130px'}} />;
          }
        },
      }
    ];

      if (!canWriteUsers) {
    tablejson = tablejson.filter(col => col.key !== "Addtoken" && col.key !== "AmountTransfered");
  }
    if(tokenFlag == 'false'){
      let availabletoken = tablejson.find(item=>item.key == 'Addtoken')
      const index = tablejson.indexOf(availabletoken);
      if (index > -1) {
        tablejson.splice(index, 1);
      }
    }
    return tablejson
  }
  
  const userExcelTableColumns = (params) => {
    let tablejson = [
      { key: "username", label: "User Name", align: "left", fontSize: "15px" },
      { key: "first_name", label: "Name", align: "left", fontSize: "15px", },
      { key: "email", label: "Email", align: "left" },
      { key: "mobile_number", label: "Mobile", align: "left", fontSize: "15px" },
      { key: "date_of_birth", label: "DOB", align: "left", fontSize: "15px" },
      { key: "address_line_1", label: "Address Line 1", align: "left", fontSize: "15px" },
      { key: "address_line_2", label: "Address Line 2", align: "left", fontSize: "15px" },
      { key: "city", label: "City", align: "left", fontSize: "15px" },
      { key: "state", label: "Region", align: "left", fontSize: "15px" },
      { key: "country", label: "Country", align: "left", fontSize: "15px" },
      { key: "nationality", label: "Nationality", align: "left", fontSize: "15px" },
      {
        key: "last_played_date", label: "Last Played Date", align: "left", fontSize: "15px",
        valueRenderer: (data) => {
          if (data.last_played_date == null) {
            return "N/A";
          } else {
            return Dateformater(data['last_played_date'])
          }

        },
      },
      { key: "available_tokens", label: "Purchased Tokens", align: "left", fontSize: "15px" },
      { key: "won_tokens", label: "Won Tokens", align: "left", fontSize: "15px" },
      // {
      //   key: "Addtoken",
      //   label: "Add Tokens",
      //   align: "center",
      //   valueRenderer: (data) => {
      //     return (
      //       <Box sx={{ width: "180px" }}>
      //         <IconButton
      //           sx={{
      //             "&:hover": {
      //               // backgroundColor: 'transparent'
      //               borderRadius: "12px",
      //             },
      //           }}
      //           onClick={() => {
      //             setPopup(true)
      //             setUserId(data)
      //           }

      //           }
      //         >
      //           <Typography
      //             sx={{
      //               color: "#3C50E0",

      //               padding: '5px',
      //               borderRadius: '10px',

      //               display: "flex",
      //               gap: 2,
      //               "&:hover": {
      //                 backgroundColor: "transparent",

      //               },
      //             }}
      //             data={data.available_tokens ? data.available_tokens : 0}
      //           >
      //             Add Tokens
      //             <Iconify
      //               icon={editicon}
      //               type="image"
      //               size="small"
      //               color="primary.main"
      //             />

      //           </Typography>
      //         </IconButton>
      //       </Box>
      //     );
      //   },
      // },
      { key: "total_rounds_playing", label: "Total Rounds", align: "left", fontSize: "15px" },
      { key: "active_rounds_playing", label: "Active Rounds", align: "left", fontSize: "15px" },
      { key: "total_gain_loss", label: "Total Gain/Loss", align: "left", fontSize: "15px" },
      {
        key: "is_active",
        label: "Status",
        align: "center",
        fontSize: '14px',
        valueRenderer: (data) => {
          if (data.is_active === true) {
            return 'Active';
          } else {
            return 'Inactive';
          }
        },
      }
    ];
    if (tokenFlag == 'false') {
      let availabletoken = tablejson.find(item => item.key == 'Addtoken')
      const index = tablejson.indexOf(availabletoken);
      if (index > -1) {
        tablejson.splice(index, 1);
      }
    }
    return tablejson
  }





 const getUsers = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
  dispatch(setUsers([]));
  try{
  
      setPopup(false)
      setLoading(true)

       // Build query parameters
      let queryParams = `page=${page}&limit=${limit}`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
       // ADD THIS: Add search parameter if provided
        if (search && search.trim() !== '') {
          queryParams += `&search=${encodeURIComponent(search.trim())}`;
        }
      // const response = await Axios.get(`${base_url}/api/accounts/user/create?type=player`, Config);
      const response = await Axios.get(`${base_url}/api/accounts/user/create?type=player&${queryParams}`, Config);
      if (response?.status == 200) {
        // let no = 1
         let startIndex = (page - 1) * limit + 1;
        let data = response?.data?.results
        data.map(item => {
          item.serial_no = startIndex
          startIndex += 1
        })
        dispatch(setUsers(data));
        setTotalCount(response?.data?.count); // Set total count from API response

      }
      setLoading(false)
      setPopup(false)
      
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)
    }
  }, []);

  const gotoAddUser = () => {
    navigate("add");
    dispatch(setSelectedUser({}));
  };

    // Handle pagination change from TransTable
  const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    // API pages usually start from 1, but MUI pagination starts from 0
    getUsers(page + 1, rowsPerPage, sortBy, sortOrder);
  }, [sortBy, sortOrder, getUsers]);

  // Handle sorting change from TransTable
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    // Reset to first page when sorting changes
    setCurrentPage(0);
    getUsers(1, rowsPerPage, orderBy, order);
  }, [rowsPerPage, getUsers]);

    // ADD THIS: Handle search from TransTable
  const handleSearch = useCallback((searchValue) => {
    setSearchQuery(searchValue);
    // Reset to first page when searching
    setCurrentPage(0);
    getUsers(1, rowsPerPage, sortBy, sortOrder, searchValue);
  }, [rowsPerPage, sortBy, sortOrder, getUsers]);

  // {
  //   key: "available_tokens",
  //   label: "Add Tokens",
  //   align: "center",
  //   valueRenderer: (data) => {
  //     return (
  //       <Box sx={{ width: "180px"}}>
  //         <IconButton
  //           sx={{
  //             "&:hover": {
  //               // backgroundColor: 'transparent'
  //               borderRadius: "12px",
  //             },
  //           }}
  //           onClick={() => {
  //             if(tokenFlag == 'true' ){

              
  //             setPopup(true)
  //             setUserId(data)}

  //           }}
  //         >
  //           <Typography
  //             sx={{
  //               color: "#3C50E0",
              
  //               padding : '5px',
  //               borderRadius:'10px',
               
  //               display: "flex",
  //               gap: 2,
  //               "&:hover": {
  //                 backgroundColor: "transparent",

  //               },
  //             }}
  //             data={data.available_tokens ? data.available_tokens : 0}
  //           >
  //             Add Tokens
  //             <Iconify
  //               icon={editicon}
  //               type="image"
  //               size="small"
  //               color="primary.main"
  //             /> 
              
  //           </Typography>
  //         </IconButton>
  //       </Box>
  //     );
  //   },
  // },
  // useEffect(() => {
  //   getUsers();
 
  // }, []);
    useEffect(() => {
    getUsers(1, 10); // Initial load
  }, []);

  const handleToken = (e) => {
    setaddTokenValue(e.target.value)
  }

  const handleAmountTransfer = (e) =>{
    setAmountTransfer(e.target.value)
  }

  //key => tokens , user -> post 
  const TokenValue = async() => {
    try{
      const response = await Axios.patch(
        `${base_url}/api/accounts/user/${userId.id}`,
        { 
          // ...userId,
          // tokens : parseInt(tokenValue),
          // user : userId.id,
          available_tokens: userId.available_tokens ? parseInt(userId.available_tokens) + (parseInt(tokenValue)) : parseInt(tokenValue)
          },

        Config
      );
      if (response?.data?.available_tokens >=0) {
        setPopup(false)
        getUsers();
      }
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)
    }
    
  }
  const amountTransfer = async() => {
    try{
      const response = await Axios.patch(
        `${base_url}/api/accounts/user/${userId.id}`,
        { 
          // ...userId,
          // tokens : parseInt(tokenValue),
          // user : userId.id,
          winningamount: Math.round(userId.winningamount) - parseInt(AmountTransfer)
          }, 

        Config
      );
      if (response ) {
        setAmountPopup(false)
        getUsers();
      }
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)
    }
    
  }

  //Excel Get Full Data Using In this Function Start
  const getAllUsersForExcel = async () => {
  try {
    setLoading(true);
    const response = await Axios.get(
      `${base_url}/api/accounts/all-users/`, // No pagination params
      Config
    );
    
    if (response?.status === 200) {
      setLoading(false);
      return response?.data?.results || response?.data; // Return the data
    }
    setLoading(false);
    return [];
  } catch (error) {
    setLoading(false);
    RefreshToken(error, setErrorMessage, setnotification);
    return [];
  }
};

// Add state to store all Excel data
const [allExcelData, setAllExcelData] = useState([]);

// Add this function to handle Excel download
const handleExcelDownload = async () => {
  try {
    setLoading(true);
    const allUsersData = await getAllUsersForExcel();
    
    if (allUsersData.length > 0) {
      setAllExcelData(allUsersData);
      // Trigger a flag that TransTable can use to download
      setTimeout(() => {
        // This will trigger the download in TransTable
        setAllExcelData(allUsersData);
      }, 100);
    } else {
      // Fallback to current displayed data if API fails
      setAllExcelData(users);
    }
  } catch (error) {
    console.error('Error downloading Excel:', error);
    // Fallback to current displayed data
    setAllExcelData(users);
  } finally {
    setLoading(false);
  }
};
  //Excel Get Full Data Using In this Function End
  return (
    <>
      <Box>
        <TransTable
          pageTitle="Players"
          addBtnTitle={'Change Player Status +'}
          showSearch={true}
          checkbox={false}
          columns={userTableColumns()}
          excelColumns ={userExcelTableColumns()}
          rows={users}
          addBtnAction={gotoAddUser}
          showAddBtn={canWriteUsers}
          filter_keys={['username', 'email', 'mobile_number']}
          isExcel={true}
          isLoading={loading}
           // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
           // ADD THIS: Pass search handler to TransTable
          onSearch={handleSearch}
          searchQuery={searchQuery}
            // Pass the Excel data and handler
              //Excel Get Full Data Using In this Function Start
        customExcelData={allExcelData}
        onExcelDownload={handleExcelDownload}
          //Excel Get Full Data Using In this Function End
        />
        <Notification
        message={errorMessage}
        setopen={setnotification}
        type={"error"}
        show={notification}
      />
      </Box>

      <ModalPopUp
        setPopup={setPopup}
        openpopup={popUp}
        title={'Add Token Value'}
        subTitle = {`${userId.username} | Available Token : ${userId.available_tokens}`}
        onChange = {handleToken}
        popupType = {'player'}
        saveBtnBg={"red"}
        onClick={TokenValue}
        save={'Add Token'}
        cancel={"Exit"}
      />
      <ModalPopUp
        setPopup={setAmountPopup}
        openpopup={amountPopup}
        title={'Amount Transfer'}
        subTitle = {`${userId.username} | Winning Amount : ${userId.winningamount}`}
        onChange = {handleAmountTransfer}
        popupType = {'player'}
        saveBtnBg={"red"}
        onClick={amountTransfer}
        save={'Update Amount'}
        cancel={"Exit"}
      />
    </>
  );
}
